import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { injectIntl, FormattedMessage } from 'react-intl'
import { Row, Col } from 'core/components/ui'
import { font } from 'assets/themes/theme-default'
import FilterTitle from '../title'

export const LabelWrapper = styled.div`
  text-align: center;
  border-radius: 20px;
  border-color: ${props => props.theme.colors.color2.bg};
  border-width: 3px;
  border-style: solid;
  padding: 5px 15px;
`

const FilterItemWrapper = styled(Col)`
  cursor: pointer;
  color: ${props => props.theme.colors.color2.bg};
  margin-bottom: 15px;
  font-size: ${font.size.sm};
  line-height: 18px;

  &.activ {
    color: ${props => props.theme.colors.color1.bg};
    ${LabelWrapper} {
      border-color: ${props => props.theme.colors.color1.bg};
    }
  }
`

/************* */

const Configuration = props => {
  const { intl, onChangeFilter, filters, filtersDatas } = props

  const { configurations } = filters
  const configurationsList = filtersDatas.configurations

  const handleClick = item => {
    const isSelected = !configurations
      ? false
      : configurations.filter(el => el === item.value).length > 0

    let extendedTypesValues = configurations ? [...configurations] : []

    if (!isSelected) {
      extendedTypesValues.push(item.value)
    } else {
      extendedTypesValues = configurations.filter(el => el !== item.value)
    }

    const extendedFiltersValues = {
      ...filters,
      configurations: extendedTypesValues
    }

    onChangeFilter(extendedFiltersValues)
  }

  const renderItem = item => {
    const { label } = item

    const isSelected = !configurations
      ? false
      : configurations.filter(el => el === item.value).length > 0

    return (
      <FilterItemWrapper
        key={label}
        onClick={() => handleClick(item)}
        className={isSelected ? 'activ' : ''}
        span={12}
        data-test="stock-vehicles-list-filters-type-FilterItemWrapper"
      >
        <LabelWrapper data-test="stock-vehicles-list-filters-type-FilterItemLabelWrapper">
          <FormattedMessage
            id={label}
            data-test="stock-vehicles-list-filters-type-FilterItemLabel"
          />
        </LabelWrapper>
      </FilterItemWrapper>
    )
  }

  return (
    <div data-test="component-stock-vehicles-list-filters-type">
      <FilterTitle
        label={intl.formatMessage({
          id: 'stock-vehicles-list-filters-type-title'
        })}
        data-test="stock-vehicles-list-filters-type-title"
      />
      <Row type="flex" gutter={15}>
        {configurationsList && configurationsList.map(item => renderItem(item))}
      </Row>
    </div>
  )
}

Configuration.propTypes = {
  intl: PropTypes.shape().isRequired,
  filtersDatas: PropTypes.shape().isRequired,
  filters: PropTypes.shape().isRequired,
  onChangeFilter: PropTypes.func.isRequired
}

export default injectIntl(Configuration)
